/**
 * Checks if the end of an annotation is within a particular node.
 *
 * @param {Array<object>} endingAnnotations
 * @param {Array<object>} parentEndingAnnotations
 * @param {object} node
 * @param {object} annotation
 * @returns {boolean}
 */
const getDoesAnnotationEndInThisNode = (
  endingAnnotations,
  parentEndingAnnotations,
  node,
  annotation,
) => {
  if (node.identifier && annotation.end !== node.identifier) {
    return false;
  }

  const annotationEndingRelativeToCurrentNode = endingAnnotations.find(
    ({ id }) => annotation.id === id,
  );
  if (annotationEndingRelativeToCurrentNode) {
    return true;
  }

  const doesAnnotationEndRelativeToParentNode = Boolean(
    parentEndingAnnotations.find(({ id }) => annotation.id === id),
  );

  const isAnnotationEndInRangeOfNodeOffset =
    annotation.endoffset >= node.startOffset &&
    annotation.endoffset <= node.endOffset;

  return (
    doesAnnotationEndRelativeToParentNode && isAnnotationEndInRangeOfNodeOffset
  );
};

export default getDoesAnnotationEndInThisNode;
